import { endOfDay, isAfter } from 'date-fns';
import { useMemo } from 'react';
import { useGetSubTopicEvents } from '../../../events/api/useGetSubTopicEvents';
import { usePermissions } from '../../../../hooks/usePermissions';

type Props = {
  subTopicId: string;
};

export function useEventsTab(props: Props) {
  const { isAdmin } = usePermissions();
  const { data: rawEvents, isLoading, error } = useGetSubTopicEvents(props.subTopicId);

  // Sort events from newest to oldest ("du plus récent au plus vieux")
  const events = useMemo(() => {
    if (!rawEvents) return [];
    return [...rawEvents].sort((a, b) => {
      const timeA = a.date ? new Date(a.date).getTime() : 0;
      const timeB = b.date ? new Date(b.date).getTime() : 0;
      return timeB - timeA;
    });
  }, [rawEvents]);

  // Find the insertion index for the "Aujourd'hui" divider
  const todayDividerIndex = useMemo(() => {
    if (events.length === 0) return -1;
    const endOfToday = endOfDay(new Date());

    // First event that is not strictly in the future (i.e. happening today or in the past)
    return events.findIndex((event) => {
      if (!event.date) return true;
      return !isAfter(new Date(event.date), endOfToday);
    });
  }, [events]);

  return {
    events,
    todayDividerIndex,
    isLoading,
    error,
    isAdmin,
  };
}
